import script from "./CurrentCalculation.vue?vue&type=script&setup=true&lang=js"
export * from "./CurrentCalculation.vue?vue&type=script&setup=true&lang=js"

import "./CurrentCalculation.vue?vue&type=style&index=0&id=4fea717c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4fea717c"]])

export default __exports__